export default "__VITE_ASSET__BoXlOUNG__"